package com.fireavert.fire_risk.data_models.responses

import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel
import kotlinx.serialization.Serializable

@Serializable
data class TenantFireRiskResponse(
    val tenantFireRiskList: List<TenantFireRiskDataModel>
)
